<template>
  <div class="tool-taxation">
    <div class="query-form">
      <el-form
        class="dataForm"
        :model="dataForm"
        label-position="left"
        label-width="0"
        :rules="rules"
        @keyup.enter="searchForm"
        @submit.prevent
        ref="dataForm"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item prop="model">
              <el-input
                v-model="dataForm.model"
                placeholder="请输入型号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="amount">
              <el-input
                v-model="dataForm.amount"
                placeholder="货值总金额"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5" class="no-line">
            <el-form-item prop="currencyId">
              <el-select
                v-model="dataForm.currencyId"
                placeholder="币别"
              >
                <el-option
                  v-for="option in currencyData"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="originPlaceId">
              <el-select
                v-model="dataForm.originPlaceId"
                placeholder="产地"
              >
                <el-option
                  v-for="option in cityData"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button
        type="primary"
        :loading="loading"
        @click="searchForm"
      >
        <template #icon>
          <el-icon><Search /></el-icon>
        </template>
        查询
      </el-button>
    </div>
    <div v-if="popup.show" v-loading="loading" class="query-result">
      <div class="close" @click="close">
        <el-icon><CircleCloseFilled /></el-icon>
      </div>
      <div class="result">
        <div v-if="!popup.result.materialId || !popup.result.customsCodeId" class="no-data">
          {{ isSign ? '暂无结果，可通过【物料管理】发起预归类' : '暂无结果，可签约后享受专家归类' }}
        </div>

        <template v-else>
          <div class="hd">
            <div class="left">
              型号：{{ popup.result.model }}
            </div>
            <div class="center">
              产地：{{ popup.result.originPlaceName }}
            </div>
            <div class="right">
              成交方式：CIF
            </div>
          </div>
          <!-- <div class="tips">在实际报关运输中，可能会产生运保费。</div> -->
          <div class="detail">
            <div v-if="popup.result.importVatRate" class="row">
              <div class="cell">
                <span>货值金额（USD）</span>
                <b class="number">{{ popup.result.amount }}</b>
              </div>
              <div class="cell calc">
                <ab-svg name="mul"></ab-svg>
              </div>
              <div class="cell">
                <span>海关汇率</span>
                <b class="number">{{ popup.result.customsRate }}</b>
              </div>
              <div class="cell calc">
                <ab-svg name="mul"></ab-svg>
              </div>
              <div class="cell">
                <span>增值税率</span>
                <b class="number">{{ (popup.result.importVatRate || 0) * 100 }}%</b>
              </div>
              <div class="cell calc">
                <ab-svg name="equal"></ab-svg>
              </div>
              <div class="cell">
                <span>增值税（CNY）</span>
                <b class="number">{{ popup.result.copeVat }}</b>
              </div>
            </div>
            <div v-if="popup.result.importTariffRate" class="row">
              <div class="cell">
                <span>货值金额（USD）</span>
                <b class="number">{{ popup.result.amount }}</b>
              </div>
              <div class="cell calc">
                <ab-svg name="mul"></ab-svg>
              </div>
              <div class="cell">
                <span>海关汇率</span>
                <b class="number">{{ popup.result.customsRate }}</b>
              </div>
              <div class="cell calc">
                <ab-svg name="mul"></ab-svg>
              </div>
              <div class="cell">
                <span>关税率　</span>
                <b class="number">{{ (popup.result.importTariffRate || 0) * 100 }}%</b>
              </div>
              <div class="cell calc">
                <ab-svg name="equal"></ab-svg>
              </div>
              <div class="cell">
                <span>关税（CNY）　</span>
                <b class="number">{{ popup.result.copeTariff }}</b>
              </div>
            </div>
            <div v-if="!popup.result.importVatRate && !popup.result.importTariffRate" class="no-data">该物料无税费</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tool-taxation', // 测算税费
  props: {
    isSign: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currencyData: [],
      cityData: [],
      dataForm: {
        currencyId: '',
        originPlaceId: '',
        transMode: 1
      },
      rules: {
        model: [
          { required: true, message: '请输入型号', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^(\-|\+)?\d+(\.\d+)?$/,
            message: '只能输入数字',
            trigger: 'blur',
          }
        ],
        currencyId: [
          { required: true, message: '请选择币别', trigger: 'change' }
        ],
        originPlaceId: [
          { required: true, message: '请选择产地', trigger: 'change' }
        ]
      },
      loading: false,
      popup: {
        show: false,
        result: {}
      }
    }
  },

  watch: {

  },

  computed: {
    
  },

  mounted() {
    // 币别
    let currencyData = this.$utils.getSessionStorage('currencyData')
    if (!currencyData || !currencyData.length) {
      this.$initSessionStorageData.getCurrencyData().then(result => {
        this.currencyData = result
      })
    } else {
      this.currencyData = currencyData
    }
    // 默认币别 - 美元
    if (!this.dataForm.currencyId) {
      let find = this.currencyData.find(e => e.name === '美元')
      this.dataForm.currencyId = find.id
    }

    // 国家
    let cityData = this.$utils.getSessionStorage('cityData')
    if (!cityData || !cityData.length) {
      this.$initSessionStorageData.getCityData().then(result => {
        this.cityData = result
      })
    } else {
      this.cityData = cityData
    }
    // 默认国家 - 中国
    if (!this.dataForm.originPlaceId) {
      let find = this.cityData.find(e => e.name === '中国')
      this.dataForm.originPlaceId = find.id
    }
  },

  methods: {
    searchForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$post('/oms/client/entrustImport/queryCalculateTax', this.dataForm, this, 'loading').then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.popup = {
                show: true,
                result: data.result
              }
            }
          })
        }
      })
    },

    close() {
      this.popup = {
        show: false,
        result: {}
      }
    }
  }
}
</script>

<style lang="scss">
.tool-taxation {
  position: relative;
  .query-form {
    height: 0.54rem;
    padding: 0.04rem;
    border: 1px solid #e5e5e5;
    border-radius: 0.08rem;
    background: linear-gradient(#fff, #f3f3f3);
    > .el-form {
      display: inline-block;
      width: calc(100% - 0.8rem);
      vertical-align: top;
      .el-row .el-col {
        position: relative;
        & + .el-col:not(.no-line)::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.075rem;
          z-index: 2;
          width: 1px;
          height: 0.3rem;
          background: #ccc;
        }
      }
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__error {
          margin-top: 0.04rem;
        }
      }
      .el-input {
        .el-input__wrapper {
          box-shadow: none !important;
          background: none !important;
          .el-input__inner {
            height: 0.42rem;
            line-height: 0.42rem;
          }
        }
      }
    }
    > .el-button {
      width: 0.8rem;
      height: 0.44rem;
      min-width: auto;
      padding: 0;
      border-radius: 0.08rem;
      vertical-align: top;
    }
  }
  .query-result {
    position: absolute;
    left: 0;
    top: 0.54rem;
    z-index: 99;
    width: 100%;
    height: 2.5rem;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.08rem;
    background: #fff;
    .close {
      position: absolute;
      top: 0.12rem;
      right: 0.15rem;
      z-index: 2;
      width: 19px;
      height: 19px;
      color: #b2b2b2;
      cursor: pointer;
      .el-icon {
        font-size: 19px;
      }
      &:hover {
        color: #0a7cff;
      }
    }
    .result {
      height: 100%;
      padding: 0.15rem 0;
      .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        color: #999;
      }
      .hd {
        display: flex;
        justify-content: space-between;
        padding: 0 0.18rem;
        line-height: 0.24rem;
        .right {
          margin-right: 0.25rem;
        }
      }
      .tips {
        width: calc(100% - 0.36rem);
        margin: 0.15rem auto 0;
        padding: 0.08rem 0.14rem;
        border-radius: 0.04rem;
        color: #f8794c;
        background: #feeae3;
      }
      .detail {
        width: calc(100% - 0.18rem);
        height: calc(100% - 0.92rem);
        margin-top: 0.18rem;
        padding: 0 0 0 0.25rem;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background: #d0d0d0;
        }
        &::-webkit-scrollbar-track {
          background: #fff;
        }
        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.15rem;
          padding-bottom: 0.15rem;
          border-bottom: 1px solid #eee;
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
          }
          .cell {
            &.calc {
              display: flex;
              align-items: center;
            }
            &:last-child {
              .number {
                color: #f87243;
              }
            }
            span {
              color: #4c4c4c;
            }
            b {
              display: block;
              margin-top: 0.04rem;
              font-size: 18px;
              color: #000;
            }
            .icon-svg {
              width: 0.1rem;
            }
          }
        }
      }
    }
  }
}
</style>
